module.exports = __webpack_public_path__ + "static/media/lacaja.841ac77c.jfif";